import type { RouteRecordRaw } from "vue-router"
import { routePaths } from "@/router/routePaths"
import { CX_CORE_FEATURES_ENUM, featureCheck } from "@/common/util/featuresUtil"

const applicationRoutes: RouteRecordRaw[] = [
  {
    path: "/applications",
    name: "applications",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.applications.certificateManagement.path,
        name: routePaths.applications.certificateManagement.pathName,
        component: () =>
          featureCheck(CX_CORE_FEATURES_ENUM.CERTIFICATE_MANAGEMENT)
            ? import("@/modules/applications/certificateManagement/pages/CertificateManagement.vue")
            : import("@/modules/error/PageNotFound.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "Business Partner Certificate Management",
              translationKey: "certificateManagement.title",
              routeName: routePaths.applications.certificateManagement.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.pcfExchange.path,
        name: routePaths.applications.pcfExchange.pathName,
        component: () =>
          featureCheck(CX_CORE_FEATURES_ENUM.PCF_EXCHANGE)
            ? import("@/modules/applications/pcfExchange/pages/PcfExchange.vue")
            : import("@/modules/error/PageNotFound.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "PCF Exchange",
              translationKey: "sideMenu.pcfExchange",
              routeName: routePaths.applications.pcfExchange.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.blockNotifications.path,
        name: routePaths.applications.blockNotifications.pathName,
        component: () =>
          featureCheck(CX_CORE_FEATURES_ENUM.BLOCK_NOTIFICATIONS)
            ? import("@/modules/applications/blockNotifications/pages/BlockNotifications.vue")
            : import("@/modules/error/PageNotFound.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "blockNotifications.title",
              translationKey: "blockNotifications.title",
              routeName: routePaths.applications.blockNotifications.pathName
            }
          ]
        }
      }
    ]
  }
]

export default applicationRoutes
